module.exports = __webpack_public_path__ + "static/media/20170806_02day_0090AT.86fefcae.jpg";